import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Plus, Trash2, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { numStr, parseNum } from "@/lib/format";
import { Button, Card, Input, Page, PageHeader, Switch } from "@/components/kit";
import { usePlans } from "@/components/master/TenantFields";

const blank = { name: "", price: "", max_units: "", max_users: "", active: true };
const toForm = (p) => ({ ...p, price: numStr(p.price), max_units: p.max_units ? String(p.max_units) : "", max_users: p.max_users ? String(p.max_users) : "" });
const toBody = (f) => ({ name: f.name, price: parseNum(f.price), max_units: parseInt(f.max_units, 10) || null, max_users: parseInt(f.max_users, 10) || null, active: f.active });

function PlanRow({ plan }) {
  const qc = useQueryClient();
  const [f, setF] = useState(plan ? toForm(plan) : blank);
  const done = (msg) => { qc.invalidateQueries({ queryKey: ["master-plans"] }); toast.success(msg); if (!plan) setF(blank); };
  const save = useMutation({ mutationFn: () => api(plan ? `/master/plans/${plan.id}` : "/master/plans", { method: plan ? "PUT" : "POST", body: toBody(f) }), onSuccess: () => done(plan ? "Plano salvo" : "Plano criado"), onError: (e) => toast.error(e.message) });
  const del = useMutation({ mutationFn: () => api(`/master/plans/${plan.id}`, { method: "DELETE" }), onSuccess: () => done("Plano excluído"), onError: (e) => toast.error(e.message) });
  const id = plan?.id || "new";
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="grid grid-cols-2 sm:grid-cols-[1.4fr_1fr_1fr_1fr_auto_auto] gap-2 items-center py-3" data-testid={`plan-row-${id}`}>
      <Input placeholder="Nome do plano" value={f.name} onChange={set("name")} className="col-span-2 sm:col-span-1" data-testid={`plan-name-${id}`} />
      <Input placeholder="R$/mês" inputMode="decimal" value={f.price} onChange={set("price")} data-testid={`plan-price-${id}`} />
      <Input placeholder="Máx. unidades" inputMode="numeric" value={f.max_units} onChange={set("max_units")} data-testid={`plan-units-${id}`} />
      <Input placeholder="Máx. usuários" inputMode="numeric" value={f.max_users} onChange={set("max_users")} data-testid={`plan-users-${id}`} />
      <div className="flex items-center gap-2"><Switch on={f.active} onChange={(v) => setF({ ...f, active: v })} data-testid={`plan-active-${id}`} /><span className="caption">Ativo</span></div>
      <div className="flex gap-1 justify-end">
        <Button size="sm" icon={plan ? Save : Plus} loading={save.isPending} onClick={() => save.mutate()} data-testid={`plan-save-${id}`}>{plan ? "Salvar" : "Criar"}</Button>
        {plan && <button className="icon-btn" onClick={() => window.confirm("Excluir plano?") && del.mutate()} data-testid={`plan-delete-${id}`}><Trash2 size={15} /></button>}
      </div>
    </div>
  );
}

export default function Plans() {
  const plans = usePlans();
  return (
    <Page>
      <PageHeader title="Planos" subtitle="Valor mensal cobrado de cada cliente e limites de uso" />
      <Card className="divide" data-testid="plans-list">
        {plans.map((p) => <PlanRow key={p.id} plan={p} />)}
        <PlanRow key="new" />
      </Card>
      <p className="caption mt-3">Campos de limite vazios = ilimitado. O cliente paga a mensalidade pelo cartão em Menu → Assinatura; cada pagamento libera mais 30 dias.</p>
    </Page>
  );
}
